"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormModal = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const BookingContact_1 = require("../../models/BookingContact");
const ContactForm_1 = require("../contact-form/ContactForm");
const ContactFormModal = (props) => {
    // Use a copy of the contact to enable cancelling.
    const [contactClone, setContactClone] = (0, react_1.useState)((0, cloneDeep_1.default)(props.contact));
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    function handleClose() {
        props.onClose();
    }
    function handleOk(e) {
        e.preventDefault();
        if (!showErrors) {
            // User clicked button for the first time. Show validation on next render.
            setShowErrors(true);
        }
        if (isValid) {
            // Test if the user actually made a change.
            if ((0, isEqual_1.default)(props.contact, contactClone)) {
                props.onClose();
            }
            else {
                props.onOk(contactClone);
            }
        }
    }
    return (react_1.default.createElement(Modal_1.default, { className: "contact-form-modal", show: true, onHide: handleClose, animation: false, centered: true, size: "lg" },
        react_1.default.createElement(Form_1.default, { onSubmit: handleOk, noValidate: true },
            react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
                react_1.default.createElement(Modal_1.default.Title, null, "Kontakt")),
            react_1.default.createElement(Modal_1.default.Body, null,
                react_1.default.createElement(ContactForm_1.ContactForm, { contact: contactClone, onContactChange: (newContact) => setContactClone((prevContact) => BookingContact_1.BookingContact.fromPartial(newContact, prevContact)), showErrors: showErrors, isValid: isValid, isValidChange: setIsValid })),
            react_1.default.createElement(Modal_1.default.Footer, null,
                react_1.default.createElement(Button_1.default, { type: "submit", variant: "primary", disabled: showErrors && !isValid, style: { minWidth: "110px" } }, "Ok"),
                react_1.default.createElement(Button_1.default, { className: "", variant: "secondary", style: { minWidth: "110px" }, onClick: handleClose }, "Schliessen")))));
};
exports.ContactFormModal = ContactFormModal;
